export default __webpack_public_path__ + "static/media/RCSP_GOLD.933783e9.svg";